// @flow

export default (t: (name: string) => string, isBradfordEnabled: boolean, isEditable: boolean) => ({
  bradfordScore: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("BRADFORD_SCORE_BS"),
      description: t("BRADFORD_SCORE_DESCRIPTION"),
    },
  },
  bradfordScoreAbsenceType: {
    "ui:widget": "select",
    "ui:readonly": !isBradfordEnabled || !isEditable,
    "ui:options": {
      label: t("BS_ABSENCE_TYPE"),
      description: t("BS_ABSENCE_TYPE_DESCRIPTION"),
      rowBackground: !isBradfordEnabled && "light-grey",
    },
  },
  bradfordScoreDayType: {
    "ui:widget": "select",
    "ui:readonly": !isBradfordEnabled || !isEditable,
    "ui:options": {
      label: t("BS_DAY_TYPE"),
      description: t("BS_DAY_TYPE_DESCRIPTION"),
      rowBackground: !isBradfordEnabled && "light-grey",
    },
  },
  bradfordScorePeriod: {
    "ui:widget": "number-input",
    "ui:readonly": !isBradfordEnabled || !isEditable,
    "ui:options": {
      label: t("BS_PERIOD_MONTHS"),
      description: t("BS_PERIOD_MONTHS_DESCRIPTION"),
      rowBackground: !isBradfordEnabled && "light-grey",
    },
  },
  "ui:order": [
    "bradfordScore",
    "bradfordScoreAbsenceType",
    "bradfordScoreDayType",
    "bradfordScorePeriod",
    "*",
  ],
});
